export const ACTION_LOGISTIQUE_MANUEL = 'Manuel';
export const ACTION_LOGISTIQUE_LAISSER_EN_PLACE = 'LaisserEnPlace';
export const ACTION_LOGISTIQUE_LAISSER_EN_PLACE_VENTE = 'LaisserEnPlaceVente';
export const ACTION_LOGISTIQUE_AFFICHAGE = 'Affichage';
